export default class AssetClass {
  /**
   * @param id GUID of this asset class.
   * @param name 
   * @param description 
   * @param fixProtocolId FIX Protocol ID of this asset class, as defined on fixtrading community dictionary for default values.
   */
  constructor(
    public id: string | undefined,
    public name: string,
    public description: string,
    public fixProtocolId: number
  ) { }
}